import React from 'react';
import { CategoriesMenu } from '@fiverr-private/categories_menu';

type CategoriesMenuProps = Exclude<Parameters<typeof CategoriesMenu>[0], 'children'>;

const CategoriesMenuWrapper: React.FC<CategoriesMenuProps> = (props) => (
    <div className="categories-menu-wrapper categories_menu-package">
        <CategoriesMenu {...props} />
    </div>
);

export default CategoriesMenuWrapper;
